import { combineReducers } from '@reduxjs/toolkit'

import aptitudeTestReducer from '../features/aptitudeTest/aptitudeTestSlice'

export default combineReducers({
  aptitudeTest: aptitudeTestReducer,
})
